import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { stripTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-sand border-y border-warmgray" data-id="element-252" data-mp="3sq1vbv6hrw06">
      <div className="max-w-7xl mx-auto px-4" data-id="element-253" data-mp="3srmszto3rv29">
        <h2 className="sr-only" data-id="element-254" data-mp="3nz21iyso5u1w">What drawing teachers are saying</h2>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-255" data-mp="3nxqy5034yobb">
          {stripTestimonials.map((t, i) => <motion.figure key={t.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-paper border border-warmgray p-6 rounded-2xl flex flex-col h-full" data-id="element-256" data-mp="5nf5qst8iazd" data-mpi={i}>
              <div className="flex gap-1 text-burnt mb-4" aria-label="5 out of 5 stars" data-id="element-257" data-mp="cek0ay8x0fdo">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" aria-hidden="true" data-id="element-258" data-mp="lbuhf08eyyqi" data-mpi={j} />)}
              </div>
              <blockquote className="text-charcoal-soft italic mb-6 text-sm leading-relaxed flex-grow" data-id="element-259" data-mp="v5b7pu9cdvpf">
                {t.text}
              </blockquote>
              <figcaption className="flex items-center gap-3 mt-auto" data-id="element-260" data-mp="144yb2llmtbl4">
                <div className="w-10 h-10 rounded-full bg-terracotta text-paper flex items-center justify-center font-bold shrink-0" data-id="element-261" data-mp="192q1fb6mopn7">
                  {t.initials}
                </div>
                <div data-id="element-262" data-mp="3aucxvs9ahcr2">
                  <div className="font-bold text-charcoal text-sm" data-id="element-263" data-mp="3attes87wkibg">
                    {t.name}
                  </div>
                  <div className="text-xs text-terracotta-dark" data-id="element-264" data-mp="i0w9l809v0mc">{t.role}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}